import { CHANGE_LANGUAGE_SUCCESS } from '@console/store/actionTypes/homepage'
import { getLang } from '@console/utils/index'

interface IState {
  currentLanguage: 'zh' | 'en'
  platform: any
}

const initialState = {
  currentLanguage: getLang(),
  platform: {}
}

export default function i18n(state: IState = initialState, { type, payload }: any) {
  switch (type) {
    case CHANGE_LANGUAGE_SUCCESS:
      if (payload) {
        return { currentLanguage: payload.currentLanguage, platform: payload.data }
      }
      return state
    default:
      return state
  }
}
